import { compose, filter, map, pathEq, prop } from 'ramda'

export const getSelectedPlaceLevelsValues = (values, type, levelId) => {
  const filteredValues = compose(
    map(prop('label')),
    filter(
      item =>
        (!type || pathEq(['origin', 'type'], type, item)) && //
        (!levelId || pathEq(['origin', 'levelId'], levelId, item))
    )
  )(values)

  if (!filteredValues) return values
  if (filteredValues.length > 5 || filteredValues.some(item => !item)) {
    return `${filteredValues.length} selecionados`
  }

  return filteredValues.join(', ')
}
